import { asCurrency, asDate, asTimelessDate, CollapsableSection, Column, Columns, FormInput } from "lqx-react";
import * as React from "react";
import { TransactionMovedToARActivity } from "api/activity";
import { Document } from "api/uploads";
import { FormLink } from "lqx-react/src/forms/horizontal";
import { CommentsCollapsable } from "./commentsSection";

export const TransactionMovedToARDetails = ({data, attachment, comment, currency } : {
    data : TransactionMovedToARActivity,
    attachment : Document,
    comment : string,
    currency : string,
}) => {
    return (
        <>
        <CommentsCollapsable attachment={attachment} comment={comment} />
        <CollapsableSection title="Transaction Details:" notExpanded>
            <Columns>
                <Column>
                    <FormInput label="Transaction Amount" value={asCurrency(data.transactionDetails.amount, currency)} />
                    <FormInput label="Value Date" value={asTimelessDate(data.transactionDetails.valueDate)} />
                </Column>
                <Column>
                    <FormInput label="Statement Date" value={asTimelessDate(data.transactionDetails.statementDate)} />
                    <FormInput label="BAI Code" value={data.transactionDetails.baiCode} />
                </Column>
            </Columns>
        </CollapsableSection>
        <CollapsableSection title="Customer Details:" notExpanded>
            <Columns>
                <Column>
                    <FormInput label="Customer Name" value={data.relationshipDetails.customerName} />
                </Column>
                <Column>
                    <FormInput label="Customer ID" value={data.relationshipDetails.customerId} />
                </Column>
            </Columns>
        </CollapsableSection>
        <CollapsableSection title="Supplier Details:" notExpanded>
            <Columns>
                <Column>
                    <FormInput label="Legal Entity Name" value={data.relationshipDetails.supplierLegalEntityName} />
                </Column>
                <Column>
                    <FormInput label="Company Code" value={data.relationshipDetails.supplierCompanyCode} />
                </Column>   
            </Columns>
        </CollapsableSection>
        </>
    );
}
